import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';

import { APP_NAME } from '../../constants';

import { getI18nByApp } from '../../services/i18n/selector';

import { addLocaleToPathIfNeeded } from '../../utils';

export class LocalizedBreadcrumbsItem extends React.Component {
    render() {
        const { i18n, disabled, showBrandName } = this.props;

        if (showBrandName) {
            return (
                <BreadcrumbsItem to={addLocaleToPathIfNeeded(this.props)} disabled={disabled}>
                    {getI18nByApp(i18n, 'common.BREADCRUMB_ROOT')
                        ? getI18nByApp(i18n, 'common.BREADCRUMB_ROOT')
                        : APP_NAME}
                </BreadcrumbsItem>
            );
        } else {
            return (
                <BreadcrumbsItem to={addLocaleToPathIfNeeded(this.props)} disabled={disabled}>
                    {this.props.children}
                </BreadcrumbsItem>
            );
        }
    }
}
const mapStateToProps = state => {
    return {
        i18n: state.i18n,
        locale: state.i18n.locale
    };
};

LocalizedBreadcrumbsItem.propTypes = {
    disabled: PropTypes.bool,
    brandName: PropTypes.bool
};

export default connect(mapStateToProps)(LocalizedBreadcrumbsItem);



// WEBPACK FOOTER //
// ./src/components/breadcrumb/LocalizedBreadcrumbsItem.js